import React, {
    useLayoutEffect,
    useRef,
    useMemo
} from 'react';
import { slick } from "@accessible360/accessible-slick";

import TicketCard from './ticket-card';
import LoadingIndicator from './loading-indicator';

export default function CardCarousel(props) {
    const containerRef = useRef(null);
    const is_carousel = props.cards?.length > 1;

    // 🧠 Sort cards by date (ascending)
    const sortedCards = useMemo(() => {
        if (!props.cards) return [];
        return [...props.cards].sort((a, b) => {
            const aDate = new Date(a.instance?.start);
            const bDate = new Date(b.instance?.start);
            return aDate - bDate;
        });
    }, [props.cards]);

    useLayoutEffect(() => {
        if (!is_carousel || !containerRef.current) return;

        const timeout = setTimeout(() => {
            const carousel = containerRef.current;
            if (!carousel || carousel.classList.contains("slick-initialized")) return;

            // Use media query to determine slide count
            const above_breakpoint = window.matchMedia("(min-width: 75em)").matches;
            const slidesToShow = above_breakpoint ? 2 : 1;

            const arrow = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22"><path fill-rule="evenodd" d="M10.6 21.3a1 1 0 0 1-1-1V3.4l-7.9 8A1 1 0 0 1 .3 9.8L9.9.3a1 1 0 0 1 1.4 0L21 9.9a1 1 0 0 1-1.5 1.4l-7.9-7.9v16.9c0 .5-.4 1-1 1Z" clip-rule="evenodd"/></svg>`;

            const slickProps = {
                dots: false,
                arrows: true,
                infinite: false,
                speed: 300,
                slidesToShow: slidesToShow,
                adaptiveHeight: false,
                arrowsPlacement: "afterSlides",
                prevArrow: '<button type="button" data-control-prev><span class="sr-only">Previous</span>' + arrow + "</button>",
                nextArrow: '<button type="button" data-control-next><span class="sr-only">Next</span>' + arrow + "</button>",
            };

            $(carousel).slick(slickProps);
        }, 0);

        return () => clearTimeout(timeout);
    }, [props.cards, containerRef.current]);

    if (!props.cards && !props.pending) return null;

    return (
        <section className={`${props.class} card-carousel__container`}>
            <h2 className='booking-pathway__header'>{props.title}</h2>

            {props.pending ? (
                <LoadingIndicator />
            ) : props.cards && props.cards.length > 0 ? (
                <div ref={containerRef} className={`${props.class}__cards card-carousel ${!is_carousel ? "not-carousel" : "is-carousel"}`}>
                    {sortedCards.map(ticket => (
                        <div key={ticket.id} className={`${props.class}__cards--item card-carousel__item`}>
                            <TicketCard ticket={ticket} type="upcoming" />
                        </div>
                    ))}
                </div>
            ) : (
                <div className="card-carousel__empty-message">
                    <p>You have no upcoming bookings.</p>
                </div>
            )}
        </section>
    );
}